// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  clientId: '2_2yxkf1u8vrms8osck0gosc8wkgs4wwg4o88okgog4o488c8wcg',
  secretId: 'jvfek78j65wc4g8cccwkkgkoowsw8o84oowoo0880kk8gkooo',
  urlApi: 'https://campus-staging.luiss.it'
};
